if (!customElements.get('localization-form')) {

    class LocalizationForm extends HTMLElement {
        constructor() {
            super();
            this.elements = {
                input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
                button: this.querySelector('button'),
                panel: this.querySelector('ul'),
            };
            this.closeDelay = 180;
            this.closeTimer = null;
            this.panelAnimation = null;

            this.elements.button.addEventListener('click', this.openSelector.bind(this));
            this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
            this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

            this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

        }

        displayLocation(){
        }

        getPanelKeyframes(isOpening) {
            const offset = this.elements.panel.classList.contains('place-above') ? 8 : -8;

            if (isOpening) {
                return [
                    { opacity: 0, transform: `translateY(${offset}px)` },
                    { opacity: 1, transform: 'translateY(0)' },
                ];
            }

            return [
                { opacity: 1, transform: 'translateY(0)' },
                { opacity: 0, transform: `translateY(${offset}px)` },
            ];
        }

        stopPanelAnimation() {
            if (this.panelAnimation) {
                this.panelAnimation.cancel();
                this.panelAnimation = null;
            }
        }

        hidePanel(immediate = false) {
            clearTimeout(this.closeTimer);
            this.elements.button.setAttribute('aria-expanded', 'false');

            if (this.elements.panel.hasAttribute('hidden')) {
                return;
            }

            if (immediate) {
                this.stopPanelAnimation();
                this.elements.panel.setAttribute('hidden', true);
                this.elements.panel.classList.remove('place-above', 'place-below', 'is-open', 'is-closing');
                this.elements.panel.style.opacity = '';
                this.elements.panel.style.transform = '';
                return;
            }

            this.elements.panel.classList.remove('is-open');
            this.elements.panel.classList.add('is-closing');
            this.stopPanelAnimation();
            this.panelAnimation = this.elements.panel.animate(this.getPanelKeyframes(false), {
                duration: this.closeDelay,
                easing: 'ease',
                fill: 'forwards',
            });

            this.closeTimer = window.setTimeout(() => {
                this.elements.panel.setAttribute('hidden', true);
                this.elements.panel.classList.remove('place-above', 'place-below', 'is-closing');
                this.elements.panel.style.opacity = '';
                this.elements.panel.style.transform = '';
                this.panelAnimation = null;
            }, this.closeDelay);
        }

        onContainerKeyUp(event) {
            if (event.code.toUpperCase() !== 'ESCAPE') return;

            this.hidePanel(true);
            this.elements.button.focus();
        }

        onItemClick(event) {
            event.preventDefault();
            const form = this.querySelector('form');
            this.elements.input.value = event.currentTarget.dataset.value;
            if (form) form.submit();
        }

        openSelector(event) {
            event.preventDefault();
            clearTimeout(this.closeTimer);
            this.stopPanelAnimation();
            this.elements.button.focus({ preventScroll: true });
            const isHidden = this.elements.panel.hasAttribute('hidden');

            if (!isHidden) {
                this.hidePanel();
                return;
            }

            this.elements.panel.classList.remove('place-above', 'place-below', 'is-closing', 'is-open');
            this.elements.panel.removeAttribute('hidden');
            this.elements.panel.style.visibility = 'hidden';

            let positionClass = 'place-below';

            if (this.closest('.vitamine-footer')) {
                positionClass = 'place-above';
            } else {
                const panelHeight = this.elements.panel.offsetHeight;
                const buttonRect = this.elements.button.getBoundingClientRect();
                const spaceAbove = buttonRect.top;
                const spaceBelow = window.innerHeight - buttonRect.bottom;

                if (spaceBelow < panelHeight && spaceAbove > spaceBelow) {
                    positionClass = 'place-above';
                }
            }

            this.elements.panel.classList.add(positionClass);
            this.elements.panel.style.visibility = '';
            this.elements.button.setAttribute('aria-expanded', 'true');
            this.panelAnimation = this.elements.panel.animate(this.getPanelKeyframes(true), {
                duration: this.closeDelay,
                easing: 'ease',
                fill: 'forwards',
            });
            this.elements.panel.classList.add('is-open');
        }

        closeSelector(event) {
            const nextTarget = event.relatedTarget;

            if (nextTarget && this.contains(nextTarget)) {
                return;
            }

            this.hidePanel();
        }
    }

    customElements.define('localization-form', LocalizationForm);
    
}
